import { Link } from "react-router-dom";
import { useEffect } from "react";

const containerStyle = {
  maxWidth: 780,
  margin: "0 auto",
  padding: "40px 24px 80px",
  color: "var(--fg)",
  lineHeight: 1.6,
} as const;

const h2 = {
  fontSize: 20,
  fontWeight: 700,
  marginTop: 32,
  marginBottom: 10,
  color: "var(--fg)",
} as const;

export function PrivacyPage() {
  useEffect(() => { document.title = "Confidentialité — sonslow"; }, []);
  const today = new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });

  return (
    <div style={containerStyle}>
      <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 4 }}>Politique de confidentialité</h1>
      <p style={{ color: "var(--fg-mute)", fontSize: 13, marginBottom: 20 }}>Dernière mise à jour : {today}</p>

      <section>
        <h2 style={h2}>1. Qui sommes-nous</h2>
        <p>
          sonslow est un service de streaming musical personnel opéré à titre non lucratif par un particulier.
          Le service utilise Spotify pour le catalogue (métadonnées) et Deezer pour la lecture audio.
        </p>
      </section>

      <section>
        <h2 style={h2}>2. Données collectées</h2>
        <p>Pour utiliser sonslow, un compte est requis. Les données stockées sont :</p>
        <ul style={{ paddingLeft: 22, marginTop: 6 }}>
          <li>Nom d'utilisateur (choisi librement, peut être un pseudonyme)</li>
          <li>Adresse e-mail (optionnelle — utilisée pour la vérification et la récupération de mot de passe)</li>
          <li>Mot de passe (haché avec Argon2, jamais stocké en clair)</li>
          <li>Historique d'écoute (titre, artiste, horodatage) — utilisé pour les recommandations et la page « Wrapped » mensuelle</li>
          <li>Bibliothèque personnelle (titres/albums/artistes likés, playlists)</li>
          <li>Préférences UI (thème, volume, fondu enchaîné) — stockées principalement côté navigateur</li>
        </ul>
      </section>

      <section>
        <h2 style={h2}>3. Données techniques</h2>
        <ul style={{ paddingLeft: 22, marginTop: 6 }}>
          <li>Adresse IP (traitement en mémoire pour le rate-limiting, non stockée durablement)</li>
          <li>User-Agent (filtrage anti-scraper)</li>
          <li>Logs d'accès nginx (7 jours de rétention maximum)</li>
        </ul>
      </section>

      <section>
        <h2 style={h2}>4. Cookies</h2>
        <p>
          sonslow n'utilise <strong>que des cookies techniques</strong> nécessaires à la session (JWT d'authentification).
          Aucun cookie de tracking, aucun outil d'analytics tiers. Les préférences UI sont stockées via <code>localStorage</code>.
        </p>
      </section>

      <section>
        <h2 style={h2}>5. Rétention</h2>
        <ul style={{ paddingLeft: 22, marginTop: 6 }}>
          <li>Historique d'écoute : purgé automatiquement au-delà de 180 jours (RGPD)</li>
          <li>Refresh tokens expirés : purgés quotidiennement</li>
          <li>Compte supprimé : purge complète immédiate</li>
        </ul>
      </section>

      <section>
        <h2 style={h2}>6. Sous-traitants</h2>
        <p>Les prestataires suivants interviennent dans le fonctionnement :</p>
        <ul style={{ paddingLeft: 22, marginTop: 6 }}>
          <li>FlokiNET (Islande) — hébergement</li>
          <li>Njalla (Suède) — bureau d'enregistrement du nom de domaine (WHOIS anonymisé)</li>
          <li>Spotify — API de métadonnées catalogue</li>
          <li>Deezer — API de streaming audio</li>
          <li>Google Gmail — envoi des e-mails transactionnels (vérification, réinitialisation)</li>
        </ul>
      </section>

      <section>
        <h2 style={h2}>7. Vos droits (RGPD)</h2>
        <p>
          Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition sur
          vos données personnelles. Vous pouvez exercer ces droits directement depuis vos <Link to="/settings">Paramètres</Link>{" "}
          (rectification, suppression du compte) ou en contactant l'opérateur via{" "}
          <a href="https://t.me/slowtlks" target="_blank" rel="noopener noreferrer">Telegram</a>.
        </p>
        <p>
          Réclamation possible auprès de l'Autorité de Protection des Données (APD) belge ou de la CNIL française.
        </p>
      </section>

      <section>
        <h2 style={h2}>8. Modifications</h2>
        <p>
          Cette politique peut être mise à jour. La date en tête de page reflète toujours la dernière révision.
        </p>
      </section>

      <div style={{ marginTop: 40, paddingTop: 24, borderTop: "1px solid var(--line)" }}>
        <Link to="/" style={{ color: "var(--fg-mute)", fontSize: 13 }}>← Retour à l'accueil</Link>
      </div>
    </div>
  );
}
